// UI: Botonera reutilizable para navegación por pasos (evita repetición)
function BotonesaPasos({ anterior, siguiente, textoSiguiente = 'Siguiente →', textoAnterior = '← Anterior', mostrarGuardar = true, onGuardar, deshabilitarSiguiente = false, deshabilitarAnterior = false, incluirPaquetesEnGuardar = false, }) {
return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-4">
    <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={anterior}
        disabled={deshabilitarAnterior}
    >
        {textoAnterior}
    </button>

    <div className="d-flex gap-2 flex-wrap">
        {mostrarGuardar && (
        <button
            type="button"
            className="btn btn-secondary"
            onClick={() => (onGuardar ? onGuardar(incluirPaquetesEnGuardar) : null)}
        >
            Guardar progreso
        </button>
        )}

        <button
        type="button"
        className="btn btn-primary"
        onClick={siguiente}
        disabled={deshabilitarSiguiente}
        >
        {textoSiguiente}
        </button>
    </div>
    </div>
);
}


export default BotonesaPasos;